import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { Modal } from '@lightspeed/flame/Modal';
import { Text } from '@lightspeed/flame/Text';

export const StyledModal = styled(Modal)`
  max-width: 840px;
  width: 840px;
`;

export const StyledContainer = styled(Box)`
  width: 220px;
  text-align: center;
`;

export const StyledText = styled(Text)`
  font-weight: 600;
  margin-bottom: 10px;
`;

export const StyledImage = styled('img')`
  width: 160px;
  align-self: center;
  margin-bottom: 10px;
`;

export const StyledBold = styled('span')`
  font-weight: 600;
`;
